import React, { useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Button, Col, FormGroup, Tab } from "react-bootstrap";
import { ErrorFieldMessage } from "../../components/ErrorFieldMessage";
import { messages } from "../messages";
import { StyledBackButton } from "../styles";
import { Image, renderImageComponent } from "../../../shared/widgets/ImageManager";
import { UseFormReturn } from "react-hook-form";
import { CustomExtra, FormType } from "../types";
import { usePropertyLocales } from "../../../../components/property-locale-provider";
import { useConfig } from "../../../../lib/config";

interface MultimediaTabPanelProps {
  extra: CustomExtra;
  methods: UseFormReturn<FormType>;
  isFromAgr: boolean;
  handlerAction: (formValue: FormType) => void;
  handleOnBack: () => void;
  setImageFiles: (images: Image[]) => void;
}

export function MultimediaTabPanel({
  extra,
  methods,
  handlerAction,
  isFromAgr,
  handleOnBack,
  setImageFiles,
}: MultimediaTabPanelProps) {
  const intl = useIntl();
  const config = useConfig();
  const allowedLocales = usePropertyLocales();

  const renderImageManager = useMemo(
    () =>
      renderImageComponent({
        schema: {
          title: intl.formatMessage(messages.fileManager),
        },
        idSchema: { $id: "" },
        formData: extra?.multimediaList,
        onChange: (event: Image[]) => setImageFiles([...event]),
        isDisabled: isFromAgr,
        config: {
          isDisabled: isFromAgr,
          locales: allowedLocales,
          maxSizeMB: config.mediaMaxSizeMB,
          maxFiles: config.mediaMaxFiles,
          minWidth: config.mediaMinWidth,
          helpText: {
            id: messages.imagesHelpText.id,
            defaultMessage: messages.imagesHelpText.defaultMessage,
            values: {
              maxFiles: 10,
            },
          },
        },
      }),
    [
      allowedLocales,
      config.mediaMaxFiles,
      config.mediaMaxSizeMB,
      config.mediaMinWidth,
      extra?.multimediaList,
      intl,
      isFromAgr,
      setImageFiles,
    ]
  );
  return (
    <Tab.Pane key="images" eventKey="images">
      <FormGroup as={Col}>
        <Col sm={12}>{renderImageManager}</Col>
        {Object.values(methods.formState.errors).length > 0 && (
          <ErrorFieldMessage {...messages.propertiesTabValidator} />
        )}
      </FormGroup>

      <Col sm={3}>
        <Button
          variant="primary"
          className="mt-3 mr-3"
          disabled={isFromAgr}
          onClick={methods.handleSubmit(handlerAction)}>
          <FormattedMessage {...messages.save} />
        </Button>
        <StyledBackButton className="mt-3" onClick={handleOnBack}>
          {intl.formatMessage(messages.goBack)}
        </StyledBackButton>
      </Col>
    </Tab.Pane>
  );
}
